import { AlternateHrefLangLink, ContentLanguageMeta, NamedMeta, PropertyMeta } from 'bernie-http';
import { ActivityPageMetaTagType } from '../../common/__generated__/api';
export var DISABLE_INDEXING_META = 'robots';
export var MEXICO_SITE_ID = 12;
export var MEXICO_REGION_ID = '117';
export var getPageData = function (context, siteId, regionId, pageId) {
  var _a, _b;
  var seoData = context.seoData;
  if (seoData) {
    var title = seoData.title;
    var hrefLangs = seoData.hreflangLinks;
    var seo_1 = {
      robots: '',
      description: '',
      canonical: (_a = seoData.canonicalUrl) === null || _a === void 0 ? void 0 : _a.value,
      additionalMeta: []
    };
    (_b = seoData.metaTags) === null || _b === void 0 ? void 0 : _b.forEach(function (tag) {
      if (tag.content && tag.metaTagValue) {
        switch (tag.metaTagType) {
          case ActivityPageMetaTagType.NAME:
            if (tag.metaTagValue === 'description') {
              seo_1.description = tag.content;
            }
            seo_1.additionalMeta.push(new NamedMeta(tag.metaTagValue, tag.content));
            break;
          case ActivityPageMetaTagType.PROPERTY:
            seo_1.additionalMeta.push(new PropertyMeta(tag.metaTagValue, tag.content));
            break;
          default:
            seo_1.additionalMeta.push(new ContentLanguageMeta(tag.metaTagValue, tag.content));
            break;
        }
      }
    });
    if (siteId === MEXICO_SITE_ID && regionId === MEXICO_REGION_ID) {
      var disableIndexing = new NamedMeta(DISABLE_INDEXING_META, 'noindex, nofollow');
      seo_1.additionalMeta.push(disableIndexing);
    }
    hrefLangs === null || hrefLangs === void 0 ? void 0 : hrefLangs.forEach(function (link) {
      return seo_1.additionalMeta.push(new AlternateHrefLangLink(link.hrefLang, link.href));
    });
    return {
      title: title,
      seo: seo_1,
      pageId: pageId
    };
  }
  return {
    title: '',
    pageId: pageId
  };
};